import request from '@/utils/request'
// 查询折线图和表格
export function LineChartAndList(query) {
    return request({
      url: '/business/achievement/getAchievementLineChartAndList',
      method: 'get',
      params: query
    })
  }
//排名 
export function classList(query) {
    return request({
      url: '/business/achievement/getAchievementListByClassId',
      method: 'get',
      params: query
    })
  }
//综合成绩
export function getTraineeList(query) {
    return request({
      url: '/business/achievement/getTraineeAchievementList',
      method: 'get',
      params: query
    })
  }